export default __webpack_public_path__ + "static/media/lipa.84b88ab5.webp";